import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { Typography } from "@mui/material";
import DOMPurify from "dompurify";

const RichTextEditor = ({
    initialValue,
    onChange,
    id,
    title,
    titleStyle,
    readonly = false,
}) => {
    const [value, setValue] = useState(() =>
        initialValue ? DOMPurify.sanitize(initialValue) : ""
    );

    useEffect(() => {
        if (initialValue === undefined) return;
        const sanitizedValue = DOMPurify.sanitize(initialValue);
        setValue(sanitizedValue);
    }, [initialValue]);

    const handleEditorChange = (content) => {
        setValue(content);
        if (onChange && id !== undefined) {
            const sanitizedContent = DOMPurify.sanitize(content);
            onChange(id, sanitizedContent);
        }
    };

    const defaultTitleStyle = {
        fontWeight: 600,
        fontSize: "18px",
        my: 1,
    };

    return (
        <div>
            {title && (
                <Typography
                    sx={{ ...defaultTitleStyle, ...(titleStyle || {}) }}
                >
                    {title}
                </Typography>
            )}
            <ReactQuill
                theme="snow"
                value={value}
                onChange={handleEditorChange}
                modules={modules}
                formats={formats}
                style={{ height: "170px" }}
                readOnly={readonly}
            />
        </div>
    );
};

const modules = {
    toolbar: [
        [{ header: [1, 2, 3, 4, 5, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }]
    ],
};

const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list"
];

export default RichTextEditor;